import Collapsible from "app/components/Collapsible/Collapsible";
import LoadingSpinner from "app/components/LoadingSpinner/LoadingSpinner";
import { useState } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import FirstTimeDepositMinimum from "./components/FirstTimeDepositMinimum/FirstTimeDepositMinimum";
import ManageFundingHeader from "./components/ManageFundingHeader/ManageFundingHeader";
import ManageFundingAccountInfo from "./components/ManageFundingMainContent/components/ManageFundingAccountInfo/ManageFundingAccountInfo";
import Terms from "./components/ManageFundingMainContent/components/ManageFundingContentInfo/components/Terms/Terms";
import ManageFundingOptions from "./components/ManageFundingOptions/ManageFundingOptions";
import Note from "./components/Note/Note";
import Verify from "./components/Verify/Verify";
import "./ManageFundingScreenDesktop.scss";
import "./ManageFundingScreenMobile.scss";

// when component loads set collapsible open/closed according to user status etc
// show collapsible sections depending on the user
// is verified - verifiedStatus boolean
// has deposited - firstTimeMinimumDepositComplete boolean
function ManageFunding(props: any) {
  const isVerified = props.user["verifiedStatus"];
  const isVerifiedAndHasDeposit =
    props.user["verifiedStatus"] &&
    props.user["firstTimeMinimumDepositComplete"];
  const isVerifiedAndNoDeposit =
    props.user["verifiedStatus"] &&
    !props.user["firstTimeMinimumDepositComplete"];
  const isfirstTimeMinimumDepositEnabled =
    props.user["firstTimeMinimumDepositEnabled"];

  const [
    isFirstTimeDepositMinimumSectionVisible,
    toggleFirstTimeDepositMinimumSectionVisible,
  ] = useState(
    !isVerified || (isfirstTimeMinimumDepositEnabled && isVerifiedAndNoDeposit)
  );

  const [
    isVerifyYourAccountSectionVisible,
    toggleVerifyYourAccountSectionVisible,
  ] = useState(!isVerified);

  const [isPaymentChannelsSectionVisible, togglePaymentChannelsSectionVisible] =
    useState(isVerifiedAndHasDeposit || isVerifiedAndNoDeposit);

  const [isNotesSectionVisible, toggleNotesSectionVisible] = useState(
    isVerifiedAndHasDeposit
  );

  const onToggleCollapsible = (section: string) => {
    switch (section) {
      case "FirstTimeDepositMinimum":
        toggleFirstTimeDepositMinimumSectionVisible(
          !isFirstTimeDepositMinimumSectionVisible
        );
        break;
      case "VerifyYourAccount":
        toggleVerifyYourAccountSectionVisible(
          !isVerifyYourAccountSectionVisible
        );
        break;
      case "PaymentChannels":
        togglePaymentChannelsSectionVisible(!isPaymentChannelsSectionVisible);
        break;
      case "Notes":
        toggleNotesSectionVisible(!isNotesSectionVisible);
        break;
      default:
        break;
    }
  };

  return (
    <>
      <ManageFundingHeader />
      <div className="manage-funding__content">
        <ManageFundingAccountInfo user={props.user} />
        <div className="manage-funding__content__info">
          {isfirstTimeMinimumDepositEnabled && (
            <Collapsible
              status={"open"}
              onToggle={() => onToggleCollapsible("FirstTimeDepositMinimum")}
              header={
                <div>
                  <FormattedMessage id="first-time-minimum-deposit" />
                </div>
              }
              content={<FirstTimeDepositMinimum user={props.user} />}
              isActive={isFirstTimeDepositMinimumSectionVisible}
              withArrows
            />
          )}
          {!isVerified && (
            <Collapsible
              status={"open"}
              onToggle={() => onToggleCollapsible("VerifyYourAccount")}
              header={
                <div>
                  <FormattedMessage id="cashier-verify-account" />
                </div>
              }
              content={<Verify />}
              isActive={isVerifyYourAccountSectionVisible}
              withArrows
            />
          )}

          <Collapsible
            status={"open"}
            onToggle={() => onToggleCollapsible("PaymentChannels")}
            header={
              <div>
                <FormattedMessage id="payment-channels" />
              </div>
            }
            content={
              props.loadingGateways ? (
                <LoadingSpinner />
              ) : (
                <ManageFundingOptions
                  gateways={props.gateways}
                  user={props.user}
                  onClickFundingHistory={() => props.onClickFundingHistory()}
                />
              )
            }
            isActive={isPaymentChannelsSectionVisible}
            withArrows
          />
          <Collapsible
            status={"open"}
            onToggle={() => onToggleCollapsible("Notes")}
            header={
              <div>
                <FormattedMessage id="cashier-please-note-title" />
              </div>
            }
            content={<Note />}
            isActive={isNotesSectionVisible}
            withArrows
          />
        </div>
        <Terms />
      </div>
    </>
  );
}

const mapStateToProps = state => ({
  user: state.userModel.user,
});

const mapDispatchToProps = (dispatch: any) => ({
  loadUser: () => {
    dispatch.userModel.loadUser();
  },
  setDefaultStatementTab: tabType => {
    dispatch.statementListModel.setDefaultTab(tabType);
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(ManageFunding));
